export default __webpack_public_path__ + "static/media/fido-blue.1832e052.png";